<template>
    <div style="text-align: center; overflow-y: hidden;">
        <img src="../../assets/images/home-logo-selvy.png" class="bi-img">
        <div class="main-container">            
            <div class="title-main">
                AI 건강 리포트
            </div>
            <div class="desc">
                <!-- 셀비 체크업은 인공지능 기반으로 당신의 건강 검진 결과를 분석하여 가까운 미래의 주요 질환에 대한 발병 위험도를 예측해 드립니다.-->
                셀비 체크업은 인공지능 기반으로 주요 10개 질환에 대하여 당신과 실제 발병자와의 건강 수치 유사도를 분석한 건강 리포트를 제공해 드립니다.
            </div>
        </div>

        <div class="row-2">
            <img src="../../assets/images/intro-img.png" class="intro-img">
        </div>

        <div class="footer">
            <div class="botton-wrapper">
                <div class="botton primaries" @click="goCheckupApp" v-ripple>
                    프리미엄 리포트 보기
                </div>
                <div class="botton default" @click="goHelloCheckup" v-ripple>
                    심플 리포트 보기
                </div>
            </div>
        </div>

        <v-introduction-popup v-if="introductionPopup" @closePopup="OnClosePopup" />

    </div>
</template>
<script>
    import { mapActions } from 'vuex'
    import VIntroductionPopup from "@/components/popup/introductionPopup.vue";
    export default {
        components: {
            VIntroductionPopup,
        },
        data() {
            return {
                introductionPopup: false
            }
        },
        computed: {
        },
        mounted() {
        },
        methods: {
			...mapActions('survey', [
				'setStep'
			]),
            //간단한 예측
            goHelloCheckup() {
                this.setStep(1)
                this.$router.push("/userTerms")
                //this.$router.push('/checkup/reportOverview')
            },
            //자세한 예측
            goCheckupApp() {
                this.introductionPopup = true;
            },
            OnClosePopup() {
				this.introductionPopup = false;
            }
        }
    }
</script>
<style scoped>

    .main-container {
        font-family: "SpoqaHanSans", sans-serif;
        text-align: center;
        padding: 0 30px;
        max-width: 500px;
        margin: auto;
    }
    .bi-img {
        margin-top: 40px;
        margin-bottom: 26px;
        width: 360px;
    }

    .title-main {
        font-weight: bold;
        font-size: 24px;
        margin-bottom: 10px;
    }
    .desc {
        font-size: 14px;
        color: #202020;
        word-break: keep-all;
    }
    .row-2 {
        max-width: 500px;        
        height: 45vh;
        display: flex;
        justify-content: center;
        align-content: center;
        align-items: center;
        vertical-align: middle;
        margin: auto;
    }
    .intro-img {
        text-align: center;
        margin: 8vh 0px 8vh 0px;
        width: 70vw;
        max-width: 280px;
    }
    .footer {
        position: fixed;
        bottom:20px;
        max-width: 500px;        
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin: auto;
    }

    .botton {
        display: inline-block;
        height: 44px;
        width: 80vw;
        max-width: 460px;
        line-height: 44px;
        border-radius: 22px;
        vertical-align: middle;
        font-weight: bold;
        margin-bottom: 10px;
        outline: none;
    }
    .botton.primaries {
        color: white;
        background-color: #3f6fff;
        box-shadow: 0 8px 20px -4px rgba(63, 111, 255, 0.5);
    }
    .botton.default {
        color: #3f6fff;
        background-color: white;
        border: #3f6fff solid 1px;
    }

    @media all and (min-height: 667px) and (max-height: 900px) {
        .footer {
            position: absolute;
            left: 0px;
            bottom: 0px;
            padding: 0px 30px 5vh 30px;
            width: 100%;
        }
    }

    @media all and (max-height: 600px) {
        .row-2 {
            height: auto;
        }
    }



</style>
